import { useEffect, useRef, useState } from 'react';
import { Replayer } from 'rrweb';
import { wsUrl, createLatenz } from '../../lib/cobrowse';

// Kanzlei-Seite: Live-Ansicht des Mandanten-Tabs und Weitergabe der Bedienung
export const useCobrowseAgent = (sitzung, onEnde) => {
  const root = useRef(null);
  const [verbunden, setVerbunden] = useState(false);
  const [groesse, setGroesse] = useState(null);
  const [seite, setSeite] = useState('');
  const [netz, setNetz] = useState({ ms: null, stufe: null });
  const [markWunsch, setMarkWunsch] = useState(null);
  const sendRef = useRef(() => {});

  useEffect(() => {
    if (!sitzung) return undefined;
    let rep = null; let ws; let zu = false; let timer; let letzteEingabe = 0; let mausT = 0; let scrollT = 0;
    const senden = (m) => ws?.readyState === 1 && ws.send(JSON.stringify({ t: 'cmd', ...m }));
    sendRef.current = senden;
    let clientDa = false; let langsam = false;
    const latenz = createLatenz((m) => ws?.readyState === 1 && ws.send(JSON.stringify(m)), (n) => { langsam = n.stufe === 'langsam'; setNetz(n); });
    const id = (n) => rep?.getMirror().getId(n);
    const binden = () => {
      const doc = rep?.iframe?.contentDocument;
      if (!doc || doc.__cbGebunden) return;
      doc.__cbGebunden = true;
      const eingabe = () => { letzteEingabe = Date.now(); };
      ['wheel', 'mousedown', 'keydown', 'touchmove'].forEach((t) => doc.addEventListener(t, eingabe, { capture: true, passive: true }));
      doc.addEventListener('click', (e) => {
        e.preventDefault(); e.stopPropagation();
        if (e.altKey) setMarkWunsch({ id: id(e.target), x: e.clientX, y: e.clientY });
        else senden({ c: 'click', id: id(e.target) });
      }, true);
      const wert = (e) => { const t = e.target; if (t && 'value' in t) senden({ c: 'input', id: id(t), v: t.value }); };
      doc.addEventListener('input', wert, true);
      doc.addEventListener('change', wert, true);
      doc.addEventListener('keydown', (e) => {
        if (['Enter', 'Escape', 'Tab'].includes(e.key)) { if (e.key !== 'Tab') e.preventDefault(); senden({ c: 'key', id: id(e.target), k: e.key }); }
      }, true);
      doc.addEventListener('scroll', (e) => {
        const jetzt = Date.now();
        if (jetzt - letzteEingabe > 600 || jetzt - scrollT < 100) return;
        scrollT = jetzt;
        const t = e.target === doc ? doc : e.target;
        const el = t === doc ? (doc.scrollingElement || doc.documentElement) : t;
        senden({ c: 'scroll', id: id(t), x: el.scrollLeft, y: el.scrollTop });
      }, true);
      doc.addEventListener('mousemove', (e) => {
        const jetzt = Date.now();
        if (jetzt - mausT < (langsam ? 350 : 70)) return;
        mausT = jetzt; senden({ c: 'maus', x: e.clientX, y: e.clientY });
      }, true);
    };
    const replayer = (erstes) => {
      root.current.innerHTML = '';
      rep = new Replayer([], { root: root.current, liveMode: true, mouseTail: false, showWarning: false, triggerFocus: false, blockClass: 'rr-block',
        // Seiten-Einblendanimationen (opacity 0 -> 1) würden im Replay pausiert bei 0 % hängen bleiben
        insertStyleRules: ['*, *::before, *::after { animation: none !important; transition: none !important; }'] });
      rep.on('resize', (d) => setGroesse({ w: d.width, h: d.height }));
      // rrweb ruft beim Rebuild document.open() auf -> alle Listener weg, Expando-Flag bleibt: daher zurücksetzen
      rep.on('fullsnapshot-rebuilded', () => { const d = rep?.iframe?.contentDocument; if (d) d.__cbGebunden = false; setTimeout(binden, 0); });
      rep.startLive(erstes.timestamp - 300);
      rep.enableInteract();
    };
    const verbinden = () => {
      ws = new WebSocket(wsUrl(sitzung.session_id, sitzung.agent_token));
      ws.onmessage = (ev) => {
        const m = JSON.parse(ev.data);
        if (latenz.handle(m)) return;
        if (m.t === 'ev' && m.e?.length) {
          if (!rep) replayer(m.e[0]);
          m.e.forEach((x) => rep.addEvent(x));
          setTimeout(binden, 0);
        } else if (m.t === 'client-da') { clientDa = true; setVerbunden(true); latenz.tick(); }
        else if (m.t === 'client-weg') { clientDa = false; setVerbunden(false); latenz.reset(); }
        else if (m.t === 'nav') setSeite(m.pfad || '');
        else if (m.t === 'ende') { zu = true; onEnde(m.von, m.grund); }
      };
      ws.onclose = (e) => { setVerbunden(false); if (!zu && e.code !== 4403 && e.code !== 4409) timer = setTimeout(verbinden, 2000); };
    };
    verbinden();
    const ping = setInterval(() => ws?.readyState === 1 && ws.send('{"t":"ping"}'), 25000);
    const mess = setInterval(() => { if (clientDa) latenz.tick(); }, 3000);
    return () => { zu = true; clearTimeout(timer); clearInterval(ping); clearInterval(mess); ws?.close(); try { rep?.destroy?.(); } catch { /* ignore */ } };
  }, [sitzung, onEnde]);

  const markieren = (text) => { if (markWunsch) sendRef.current({ c: 'markieren', ...markWunsch, text: (text || '').trim().slice(0, 80) }); setMarkWunsch(null); };
  return { root, verbunden, groesse, seite, netz, markWunsch, markieren, markAbbrechen: () => setMarkWunsch(null) };
};
